<template>
  <b-modal
    id="paymentMethodItemModal"
    ref="paymentMethodItemModal"
    size="lg"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
  >
    <b-form id="paymentMethodForm" @submit.prevent="savePaymentMethod">
      <b-form-group label-cols="3" label="ชื่อ (ไทย):" label-align="right">
        <b-form-input
          class="required"
          v-model="paymentItem.name"
          :class="{ 'is-invalid': $v.paymentItem.name.$error }"
          maxlength="100"
          placeholder="กรอกชื่อช่องทางชำระเงิน"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="Name (EN):" label-align="right">
        <b-form-input
          v-model="paymentItem.nameEn"
          maxlength="100"
          placeholder="Enter payment method name"
        ></b-form-input>
      </b-form-group>

      <b-form-group label-cols="3" label="หมวดหมู่:" label-align="right">
        <b-form-select
          class="required"
          v-model="paymentItem.paymentCateId"
          :class="{ 'is-invalid': $v.paymentItem.paymentCateId.$error }"
          :options="paymentCategoryOptions"
          :disabled="isDcPayment"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- เลือกหมวดหมู่ --</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group label-cols="3" label="ประเภทการชำระ:" label-align="right">
        <b-form-select
          v-model="paymentItem.settlementType"
          :options="settlementTypeOptions"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        v-if="paymentItem.settlementType === 'receivable'"
        label-cols="3"
        label="คู่สัญญา:"
        label-align="right"
      >
        <multiselect
          v-model="selectedDebtor"
          :options="debtorOptions"
          :class="{ 'is-invalid': $v.paymentItem.debtorId.$error }"
          track-by="value"
          label="text"
          placeholder="ค้นหาคู่สัญญา..."
          :searchable="true"
          :allow-empty="false"
          select-label=""
          deselect-label=""
          selected-label=""
        ></multiselect>
      </b-form-group>

      <b-form-group label-cols="3" label="ค่าธรรมเนียม:" label-align="right">
        <b-input-group append="%">
          <b-form-input
            v-model="paymentItem.processingFee"
            type="number"
            step="0.1"
            min="0"
            max="100"
            placeholder="0"
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <b-form-group label-cols="3" label="รหัส ERP:" label-align="right">
        <b-form-input
          v-model="paymentItem.erpCode"
          maxlength="20"
          placeholder="กรอกรหัส ERP"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        v-if="isChainClinic && isNew"
        label-cols="3"
        label="สาขา:"
        label-align="right"
      >
        <multiselect
          v-model="selectedBranches"
          :options="branchOptions"
          track-by="value"
          label="text"
          placeholder="ค้นหาสาขา..."
          :searchable="true"
          :multiple="true"
          :close-on-select="false"
          select-label=""
          deselect-label=""
          selected-label=""
        ></multiselect>
        <small class="text-muted">ไม่เลือก = ทุกสาขา</small>
      </b-form-group>

      <b-form-group
        v-if="isChainClinic && !isNew"
        label-cols="3"
        label="สาขา:"
        label-align="right"
      >
        <multiselect
          v-model="selectedBranch"
          :options="[{ value: null, text: 'ทุกสาขา' }, ...branchOptions]"
          track-by="value"
          label="text"
          placeholder="ค้นหาสาขา..."
          :searchable="true"
          :allow-empty="false"
          select-label=""
          deselect-label=""
          selected-label=""
        ></multiselect>
      </b-form-group>
    </b-form>

    <template v-slot:modal-footer>
      <b-button v-if="!isNew && !isDcPayment" variant="danger" @click="deletePaymentMethod">
        ลบรายการ
      </b-button>
      <b-button type="submit" form="paymentMethodForm" variant="primary">
        {{ isNew ? "สร้างรายการ" : "แก้ไขรายการ" }}
      </b-button>
    </template>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "PaymentMethodItemModal",
  components: {
    Dialog,
    Loading,
  },
  props: {
    paymentCategoryOptions: {
      type: Array,
      default: () => [],
    },
    paymentCategories: {
      type: Array,
      default: () => [],
    },
    debtorOptions: {
      type: Array,
      default: () => [],
    },
    branchOptions: {
      type: Array,
      default: () => [],
    },
    isChainClinic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      isNew: true,
      isDcPayment: false,
      selectedDebtor: null,
      selectedBranches: [],
      selectedBranch: null,
      settlementTypeOptions: [
        { value: "paid", text: "ปกติ" },
        { value: "receivable", text: "คู่สัญญา" },
      ],
      paymentItem: {
        id: null,
        name: "",
        nameEn: "",
        paymentCateId: null,
        settlementType: "paid",
        debtorId: null,
        processingFee: null,
        erpCode: "",
        branchId: null,
        branchIds: [],
      },
    };
  },
  validations: {
    paymentItem: {
      name: { required },
      paymentCateId: { required },
      debtorId: {
        required: requiredIf(function () {
          return this.paymentItem.settlementType === "receivable";
        }),
      },
    },
  },
  watch: {
    "paymentItem.paymentCateId"(newCateId) {
      if (!newCateId) return;
      const category = this.paymentCategories.find(c => c.id === newCateId);
      if (category && (category.type === "Receivable" || (category.name && category.name.includes("คู่สัญญา")))) {
        this.paymentItem.settlementType = "receivable";
      }
    },
    selectedDebtor(val) {
      this.paymentItem.debtorId = val ? val.value : null;
    },
    selectedBranches(val) {
      this.paymentItem.branchIds = val ? val.map(b => b.value) : [];
    },
    selectedBranch(val) {
      this.paymentItem.branchId = val ? val.value : null;
    },
  },
  computed: {
    modalTitle() {
      return this.isNew ? "เพิ่มช่องทางชำระเงิน" : "แก้ไขช่องทางชำระเงิน";
    },
  },
  methods: {
    show(data) {
      if (data) {
        this.isNew = false;
        this.isDcPayment = !!data.dcPaymentType;
        this.paymentItem = {
          id: data.id,
          name: data.name || "",
          nameEn: data.nameEn || "",
          paymentCateId: data.paymentCateId,
          settlementType: data.settlementType || "paid",
          debtorId: data.debtorId || null,
          processingFee: data.processingFee,
          erpCode: data.erpCode || "",
          branchId: data.branchId || null,
          branchIds: [],
        };
        // Set multiselect objects from IDs
        this.selectedDebtor = this.debtorOptions.find(d => d.value === data.debtorId) || null;
        this.selectedBranch = data.branchId
          ? this.branchOptions.find(b => b.value === data.branchId) || null
          : { value: null, text: "ทุกสาขา" };
        this.selectedBranches = [];
      } else {
        this.isNew = true;
        this.isDcPayment = false;
        this.setDefaultValue();
      }
      this.$bvModal.show("paymentMethodItemModal");
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
      this.isNew = true;
      this.isDcPayment = false;
      this.$bvModal.hide("paymentMethodItemModal");
    },
    setDefaultValue() {
      this.paymentItem = {
        id: null,
        name: "",
        nameEn: "",
        paymentCateId: null,
        settlementType: "paid",
        debtorId: null,
        processingFee: null,
        erpCode: "",
        branchId: null,
        branchIds: [],
      };
      this.selectedDebtor = null;
      this.selectedBranches = [];
      this.selectedBranch = null;
    },
    savePaymentMethod() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$emit("save", {
        isNew: this.isNew,
        isDcPayment: this.isDcPayment,
        paymentItem: { ...this.paymentItem },
      });
      this.close();
    },
    deletePaymentMethod() {
      this.$refs.Dialog.showAlertConfirm(
        "ลบช่องทางชำระเงินนี้ ?",
        `คุณต้องการลบ "${this.paymentItem.name}" ใช่หรือไม่`
      ).then(result => {
        if (!result.value) return;
        this.$emit("delete", {
          paymentItem: { ...this.paymentItem },
        });
        this.close();
      });
    },
  },
};
</script>
